<template>

  <m-box title="Geography">
    <div class="m-block" style="margin-bottom: 0; ">
      <div class="m-slide-height">
        <p v-show="geos.length === 0">Choose the type of geographic area you wish to use to target your prospects</p>
        <m-slide-item :items="geos" :deleteFun="deleteGeo"/>
      </div>
      <b-btn class="m-btn-pup" @click="$router.push({name:'geo'})"> Edit</b-btn>
    </div>
  </m-box>
</template>

<script>
  import MBox from '@/components/common/MBox'
  import MSlideItem from '@/components/slide/MSlideItem.vue'

  export default {
    components: {
      MBox,
      MSlideItem
    },
    data () {
      return {}
    },
    computed: {
      geos () {
        return this.$store.getters['order/geos']
      }
    },
    methods: {
      deleteGeo (item) {
        this.$store.commit('order/deleteGeo', item.GeoKeyCode)
      }
    }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/order2/MOrder2Geo.vue